import { borderStyles } from '../borders.js';
import { colors } from '../colors.js';
import { opacity } from '../opacity.js';
import { space } from '../spacing.js';
import { textDecorationThicknesses, textDecorationLines, } from '../typography.js';
import { paragraphs } from './paragraphs.js';
export const baseLink = {
    cursor: 'pointer',
    background: 'none',
    borderStyle: borderStyles.none,
    padding: space.x0,
    color: 'primary',
    textDecorationLine: 'none',
    textDecorationThickness: textDecorationThicknesses.s,
};
export const linkVariants = {
    ...paragraphs,
};
export const linkSettings = {
    standalone: {
        textDecorationThickness: 's',
        fontWeight: 'standard',
        color: 'primary',
        textDecorationLine: 'none',
        ':hover': {
            color: colors.controls.primaryHover,
            textDecorationLine: textDecorationLines.underline,
        },
        ':active': {
            color: colors.controls.primaryActive,
        },
        ':visited': {
            color: colors.brand.deepLavendar,
        },
    },
    inline: {
        textDecorationThickness: 's',
        fontWeight: 'standard',
        fontSize: 'inherit',
        color: 'inherit',
        textDecorationLine: 'underline',
        ':hover': {
            opacity: opacity.faded,
            color: colors.inherit,
        },
        ':active': {
            color: colors.inherit,
        },
        ':visited': {
            color: colors.inherit,
        },
    },
};
//# sourceMappingURL=links.js.map